<app-header></app-header>
<div class="title"></div>
<div>
  <div class="container margin-top-70">
    <div class="row">
      <div class="col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Product ID
              </td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="selectedproductId"
                  placeholder=""
                />
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Status
              </td>
              <td>
                <app-drop-down-single-select
                  [DropDownOptions]="dropdownListBookStatus"
                  (typeSelectedChanged)="updateSelectedType($event)"
                  [name]="'status'"
                ></app-drop-down-single-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Book Type
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'bookType'"
                  [DropDownOptions]="listBookType"
                  (typeSelectedChanged)="updateSelectedType($event)"
                ></app-drop-down-single-select>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Is Derivative
              </td>
              <td>
                <input type="checkbox" [(ngModel)]="isDerivative" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div>
  <div class="container" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Product Id</th>
          <th scope="col">Title</th>
          <th scope="col">Book Type</th>
          <th scope="col">ISBN-13P</th>
          <th scope="col">ISBN-10P</th>
          <th scope="col">ISBN-13E</th>
          <th scope="col">ISBN-10E</th>
          <th scope="col">Contracted Date</th>
          <th scope="col">Published Date</th>
          <th scope="col">Status</th>
          <th scope="col">PD Accepted</th>
          <th scope="col">FD Accepted</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.part_number}}</td>
          <td>{{product.name}}</td>
          <td>{{product.book_type}}</td>
          <td>{{product.isbn_13}}</td>
          <td>{{product.isbn_10}}</td>
          <td>{{product.isbn_13e}}</td>
          <td>{{product.isbn_10e}}</td>
          <td>{{product.contracted_date}}</td>
          <td>{{product.publishing_date}}</td>
          <td>{{product.status}}</td>
          <td>{{product.pd_accepted_percentage}}</td>
          <td>{{product.fd_accepted_percentage}}</td>
          {{assignTotalValue(product?.total_count)}}
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
